import { Component } from '@angular/core';

@Component({
	selector: 'loading-overlay',
	template: ` <mat-spinner></mat-spinner> `,
	styles: [],
	standalone: false,
})
export class LoadingOverlayComponent {}
